import { BorrowerDocumentationRequired, BorrowerOnboardingDetails, Loan } from '@nemuru-eng/js-api-client';
import { createContext, ReactElement, useContext, useReducer } from 'react';

export interface DocumentsValidationInitialData {
  loan: Loan;
  borrowerDocumentationRequired: BorrowerDocumentationRequired;
  borrowerOnboardingDetails: BorrowerOnboardingDetails;
}

const InitialState = (data: DocumentsValidationInitialData) => ({
  ...data,
});

type DocumentsValidationContextInitialState = ReturnType<typeof InitialState>;

const reducer = (
  state: DocumentsValidationContextInitialState,
  newState: Partial<DocumentsValidationContextInitialState>,
) => ({
  ...state,
  ...newState,
});

const useSectionReducer = (data: DocumentsValidationInitialData) => {
  const [state, dispatch] = useReducer(reducer, InitialState(data));

  const update = (newContext: Partial<DocumentsValidationContextInitialState>) => dispatch(newContext);

  return { ...state, update };
};

type DocumentsValidationContextState = ReturnType<typeof useSectionReducer>;

const DocumentsValidationContext = createContext<DocumentsValidationContextState | null>(null);

interface DocumentsValidationContextProviderProps {
  data: DocumentsValidationInitialData;
  children: ReactElement;
}

const DocumentsValidationContextProvider = ({ children, data }: DocumentsValidationContextProviderProps) => {
  const { ...state } = useSectionReducer(data);

  return <DocumentsValidationContext.Provider value={{ ...state }}>{children}</DocumentsValidationContext.Provider>;
};

const useDocumentsValidationContext = (): DocumentsValidationContextState => {
  const context = useContext(DocumentsValidationContext);

  if (!context) {
    throw new Error('useDocumentsValidation Context must be used within an DocumentsValidationContextProvider');
  }
  return context;
};

export { DocumentsValidationContextProvider, useDocumentsValidationContext };
